import React from 'react';
import { AppLayout } from '../../components/AppLayout';

export const ContactPage: React.FC = () => {
  return (
    <AppLayout>
      <h1>Work in Progress</h1>
    </AppLayout>
  );
};
